import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpUtils } from '../../shared/http-utils';
import { URL_BASE } from '../../core/constants';
import { LoadHandover } from './load-handover.model';
import { LoadHandoverGroup } from './load-handover-group.model';
import { map } from 'rxjs/operators';

@Injectable()
export class LoadHandoverService {

  private LOAD_HANDOVERS_URI = 'load-handovers';

  constructor(private http: HttpClient) {
  }

  public getLoadHandoversForSelfCarrier(): Observable<LoadHandoverGroup[]> {
    const headers = HttpUtils.createHeaders();
    const url     = `${URL_BASE}/api/${this.LOAD_HANDOVERS_URI}/by/carrier/self`;

    return this.http.get(url, { headers })
      .pipe(
        map((loadHandoverGroups: any[]) => loadHandoverGroups.map(g => LoadHandoverGroup.fromDto(g)))
      );
  }

  public getLoadHandoversForCarrier(carrierId: string): Observable<LoadHandoverGroup[]> {
    const headers = HttpUtils.createHeaders();
    const url     = `${URL_BASE}/api/${this.LOAD_HANDOVERS_URI}/by/carrier/${carrierId}`;

    return this.http.get(url, { headers })
      .pipe(
        map((loadHandoverGroups: any[]) => loadHandoverGroups.map(g => LoadHandoverGroup.fromDto(g)))
      );
  }

  public getLoadHandoversByLoadUuidForSelfCarrier(loadUuid: string): Observable<LoadHandover[]> {
    const headers = HttpUtils.createHeaders();
    const url     = `${URL_BASE}/api/${this.LOAD_HANDOVERS_URI}/by/carrier/self/and/load/${loadUuid}`;

    return this.http.get(url, { headers })
      .pipe(
        map((loadHandovers: any[]) => loadHandovers.map(l => LoadHandover.fromDto(l)))
      );
  }

  public getLoadHandoversByLoadUuidForCarrier(carrierId: string, loadUuid: string): Observable<LoadHandover[]> {
    const headers = HttpUtils.createHeaders();
    const url     = `${URL_BASE}/api/${this.LOAD_HANDOVERS_URI}/by/carrier/${carrierId}/and/load/${loadUuid}`;

    return this.http.get(url, { headers })
      .pipe(
        map((loadHandovers: any[]) => loadHandovers.map(l => LoadHandover.fromDto(l)))
      );
  }

}
